import { Fragment, useState } from "react";
import { Card, CardBody, Col, Popover, PopoverBody, PopoverHeader } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonPopover from "../Common/CommonPopover";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { PopoverDirectionTitle, PopoverOnTop } from "../../../../Constants/Constants";
import { PopoverDirectionSubTitle, PopoverPositions } from "../../../../Data/UiKits/Popover";

const PopoverDirection = () => {
  const [popover, setPopover] = useState(false);
  const toggle = () => setPopover(!popover);

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={PopoverDirectionTitle} span={PopoverDirectionSubTitle} />
        <CardBody className="common-flex popover-wrapper">
          <Btn color="warning" className="example-popover" id="TopPopover" onClick={toggle}>
            {PopoverOnTop}
          </Btn>
          <Popover placement="top" isOpen={popover} target="TopPopover" toggle={toggle}>
            <PopoverHeader>{PopoverOnTop}</PopoverHeader>
            <PopoverBody>{"Popovers need the tooltip plugin considering that a dependency."}</PopoverBody>
          </Popover>
          {PopoverPositions &&
            PopoverPositions.map((item, index) => (
              <Fragment key={index}>
                <CommonPopover data={item} />
              </Fragment>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default PopoverDirection